module.exports = __webpack_public_path__ + "img/pedro-castillo.e4c1d0f0.png";